export const calculateShownVideoFrames = (
  frames: string[],
  videoThumbnailWidth: number,
  pixelsPerSecond: number,
  frameSpacing: number
): string[] => {
  const framesMinCount =
    Math.ceil(videoThumbnailWidth / (pixelsPerSecond * frameSpacing)) || 1

  const missingFramesCount =
    framesMinCount - frames.length > 0 ? framesMinCount - frames.length : 0

  if (missingFramesCount) {
    // Not enough frames: pad by repeating the last frame
    const last = frames.length > 0 ? frames[frames.length - 1] : ''
    return [...frames, ...Array(missingFramesCount).fill(last)]
  }

  return frames.filter((_, index) => index % frameSpacing === 0)
}
